export const handlePhoneNumberChange = (realChangeFn: Function, e) => {
  let value = e.target.value.replace(/\D/g, '');

  value = value.replace(/^(\+?90|90|9|0)/, '');

  if (value.length > 10) {
    return;
  }

  const formattedValue = formatPhoneNumber(value);

  realChangeFn(formattedValue);
};

export const handlePhoneNumberKeyDown = (realChangeFn: Function, e) => {
  if (e.key === 'Backspace') {
    let value = (e.target.value || '').replace(/\D/g, '');

    if (value.length === 0) {
      return;
    }

    value = value.slice(0, -1);

    const formattedValue = formatPhoneNumber(value);

    realChangeFn(formattedValue);
    e.preventDefault();
  }
};

export function formatPhoneNumber(value: string): string {
  return value.slice(-10).replace(/(\d{0,3})(\d{0,3})(\d{0,4})/, (_, p1, p2, p3) => {
    let result = '';
    if (p1) result += `(${p1}`;
    if (p1.length === 3) result += `)`;
    if (p2) result += ` ${p2}`;
    if (p2.length === 3) result += `-`;
    if (p3) result += `${p3}`;
    return result;
  });
}

export const phoneRegex = new RegExp(
  /^(?:\+90.?5|0090.?5|905|0?5)(?:[0123456789][0-9])\s?(?:[0-9]{3})\s?(?:[0-9]{2})\s?(?:[0-9]{2})$/,
);

export const emailRegex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
